import { render, staticRenderFns } from "./FormElements.vue?vue&type=template&id=27f66208&scoped=true"
import script from "./FormElements.vue?vue&type=script&lang=ts"
export * from "./FormElements.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f66208",
  null
  
)

export default component.exports